module.exports = __webpack_public_path__ + "img/bg-arrogance.51d21c2f.png";